Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SoundCloud", {
  enumerable: true,
  get: function get() {
    return _soundcloud.SoundCloud;
  }
});
var _soundcloud = require("./soundcloud");